import React from 'react';

interface QuickStatsOverviewProps {
  reportCard: any;
  formatTime: (seconds: number) => string;
}

const QuickStatsOverview: React.FC<QuickStatsOverviewProps> = ({ reportCard, formatTime }) => {
  if (!reportCard) return null;

  return (
    <div className="row g-4 mb-4">
      <div className="col-md-3">
        <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
          <div className="card-body text-center p-4">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
              style={{
                width: '60px',
                height: '60px',
                backgroundColor: '#667eea15',
                border: '2px solid #667eea'
              }}>
              <i className="fas fa-clipboard-list text-primary fa-lg"></i>
            </div>
            <h3 className="fw-bold mb-1">{reportCard.total_quizzes_taken}</h3>
            <p className="text-muted mb-0">Total Quizzes</p>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
          <div className="card-body text-center p-4">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
              style={{
                width: '60px',
                height: '60px',
                backgroundColor: '#28a74515',
                border: '2px solid #28a745'
              }}>
              <i className="fas fa-bullseye text-success fa-lg"></i>
            </div>
            <h3 className="fw-bold mb-1">{reportCard.total_questions_attempted}</h3>
            <p className="text-muted mb-0">Total Questions</p>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
          <div className="card-body text-center p-4">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
              style={{
                width: '60px',
                height: '60px',
                backgroundColor: '#fd7e1415',
                border: '2px solid #fd7e14'
              }}>
              <i className="fas fa-clock text-warning fa-lg"></i>
            </div>
            <h3 className="fw-bold mb-1">{formatTime(parseInt(reportCard.total_time_spent_seconds))}</h3>
            <p className="text-muted mb-0">Study Time</p>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
          <div className="card-body text-center p-4">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
              style={{
                width: '60px',
                height: '60px',
                backgroundColor: '#dc354515',
                border: '2px solid #dc3545'
              }}>
              <i className="fas fa-trophy text-danger fa-lg"></i>
            </div>
            <h3 className="fw-bold mb-1">{parseFloat(reportCard.highest_quiz_score).toFixed(1)}%</h3>
            <p className="text-muted mb-0">Best Score</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickStatsOverview;
